<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入标题" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="分类" prop="search_category_uuid">
                <CaseCategory v-model="query.search_category_uuid"> </CaseCategory>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('algl_allb_alfl') || permission('algl_allb_xz')">
            <el-button v-if="permission('algl_allb_alfl')" size="mini" type="primary" @click="handleCategory"> 案例分类 </el-button>
            <el-button v-if="permission('algl_allb_xz')" size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100" />
            <el-table-column label="案例标题" align="center" prop="name" />
            <el-table-column label="分类" align="center" prop="category.name" />
            <el-table-column label="创建日期" align="center" prop="create_time" />
            <el-table-column
                v-if="permission('algl_allb_ckxq') || permission('algl_allb_bj') || permission('algl_allb_sc')"
                label="操作"
                align="center"
                width="180"
            >
                <template slot-scope="{ row }">
                    <el-button v-if="permission('algl_allb_ckxq')" size="mini" type="text" @click="handleDetail(row)"> 查看详情 </el-button>
                    <el-button v-if="permission('algl_allb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                    <el-button v-if="permission('algl_allb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/case/list";
import listMixin from "@/mixins/list";
import CaseCategory from "@/components/CaseCategory";

export default {
    components: { CaseCategory },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                search_category_uuid: "",
            },
            module: "案例",
            formPath: "/case/list/form",
            detailPath: "/case/list/detail",
            uuidKey: "cuuid",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleCategory() {
            this.$router.push({ path: "/case/category" });
        },
    },
};
</script>
